import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PaymentsPage } from '@/features/commercial/payments-page';

const searchSchema = z.object({
  certificate: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/payments')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <PaymentsPage projectId={projectId} certificate={search.certificate} />;
}
